import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../lib/motion";

export const STATUS_TONES = {
    verified: {
        dot: "bg-emerald-400",
        text: "text-emerald-400",
        border: "border-emerald-400/60",
    },
    visualised: {
        dot: "bg-[#60A5FA]",
        text: "text-[#60A5FA]",
        border: "border-[#60A5FA]/60",
    },
    assumed: {
        dot: "bg-accent",
        text: "text-accent",
        border: "border-accent/60",
    },
    analysis: {
        dot: "bg-accent",
        text: "text-accent",
        border: "border-accent/60",
    },
    review: {
        dot: "bg-accent",
        text: "text-accent",
        border: "border-accent/60",
    },
    spec: {
        dot: "bg-mist",
        text: "text-mist",
        border: "border-white/25",
    },
    supported: {
        dot: "bg-white",
        text: "text-white/80",
        border: "border-white/30",
    },
};

export const SectionIntro = ({
    eyebrow,
    title,
    copy,
    align = "left",
    testid,
}) => (
    <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        data-testid={testid}
        className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}
    >
        <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
            {eyebrow}
        </p>
        <h2 className="mt-5 font-display text-3xl font-semibold leading-[1.12] tracking-tight text-white md:text-5xl">
            {title}
        </h2>
        {copy ? (
            <p className="mt-5 text-[16px] leading-relaxed text-mist">{copy}</p>
        ) : null}
    </motion.div>
);

export const DemoChip = ({ children }) => (
    <span className="border border-white/20 px-2 py-0.5 font-mono text-[13px] tracking-[0.22em] text-mist">
        {children}
    </span>
);

export const WireframeHouse = ({ className = "" }) => (
    <svg
        viewBox="0 0 600 380"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        className={className}
        aria-hidden="true"
    >
        <path d="M20 330H580" />
        <path d="M20 344V330M580 344V330" />
        <path d="M70 330V180H270V330" />
        <path d="M270 330V120H520V330" />
        <path d="M70 180H270M340 120L430 66L520 120" />
        <path d="M70 210H270" />
        <path d="M100 330V210M130 330V210M160 330V210M190 330V210" />
        <path d="M300 330V150M330 330V150M360 330V150M390 330V150M420 330V150M450 330V150M480 330V150" />
        <path d="M240 330V260H260V330" />
        <path d="M70 356H520M70 350V362M520 350V362" />
        <text
            x="295"
            y="376"
            fill="#64748B"
            stroke="none"
            fontSize="10"
            fontFamily="JetBrains Mono, monospace"
            textAnchor="middle"
        >
            18.60 M
        </text>
        <circle cx="556" cy="66" r="12" />
        <text
            x="556"
            y="70"
            fill="#FF5B00"
            stroke="none"
            fontSize="10"
            fontFamily="JetBrains Mono, monospace"
            textAnchor="middle"
        >
            A
        </text>
        <path d="M556 78V120H520" strokeDasharray="3 3" />
    </svg>
);
